export interface CustomFieldDefinition {
    id: string;
    entity_type: string;
    display_name: string;
    name: string;
    data_type: string;
}
